module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_01@2x-6524c6b63f35483db37caeb038b1c25b.webp";